var _taggedTemplateLiteral = require("/usr/src/app/www/app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VARIANT_WITH_PRODUCT_FRAGMENT = void 0;

var graphql_tag_1 = __importDefault(require("graphql-tag"));

var variantFragment_1 = require("./variantFragment");

exports.VARIANT_WITH_PRODUCT_FRAGMENT = (0, graphql_tag_1.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment VariantWithProductFragment on ProductVariant {\n    ...VariantFragment\n    product {\n      description\n      handle\n      id\n      productType\n      tags\n      vendor\n    }\n  }\n  ", "\n"])), variantFragment_1.VARIANT_FRAGMENT);